import { LogOut } from 'lucide-react';
import { RadarLanguagePicker, useRadarLocale } from '@/i18n/RadarLocaleContext';
import '@/styles/radar-account.css';

export function RadarAccountBar({ signedIn, signingOut, failed, onSignOut }: {
  signedIn: boolean;
  signingOut: boolean;
  failed: boolean;
  onSignOut: () => void;
}) {
  const { t } = useRadarLocale();
  return <div className="radar-account-bar">
    <div className="radar-account-controls">
      <RadarLanguagePicker/>
      {signedIn && <button type="button" className="radar-logout" onClick={onSignOut}
        disabled={signingOut} aria-busy={signingOut} title={t('Log out of this browser')}>
        <LogOut size={16} aria-hidden="true"/>
        {t(signingOut ? 'Logging out…' : 'Log out')}
      </button>}
    </div>
    {signedIn && failed && <p className="radar-logout-error" role="alert">{t('Could not log out. Please try again.')}</p>}
  </div>;
}
